import {DunningData} from '../model/dunning-data.interface';

/**
 * Mock Dunning Data Set 3 - Simple scenario
 * Customer with 2 contracts, minimal charges
 */
export const MOCK_DUNNING_DATA_3: DunningData = {
  customerId: 10003,
  customerBillingAccountId: 20003,
  dunningId: 30003,
  contracts: [
    {
      identifier: '72889401',
      partner: 'Barmenia',
      type: 'Dental Insurance',
      monthlyPrice: [
        {
          startMonth: '2024-01',
          monthlyPrice: 12.50
        }
      ],
      currency: 'EUR',
      dunningMonths: 2,
      reactivationMonths: 3,
      dunningAmount: 25.00,
      reactivationAmount: 37.50,
      status: 'in-dunning'
    },
    {
      identifier: '72889402',
      partner: 'Debeka',
      type: 'Life Insurance',
      monthlyPrice: [
        {
          startMonth: '2024-03',
          monthlyPrice: 8.75
        }
      ],
      currency: 'EUR',
      dunningMonths: 3,
      reactivationMonths: 4,
      dunningAmount: 26.25,
      reactivationAmount: 35.00,
      status: 'in-dunning'
    }
  ],
  charges: [
    {
      name: 'Late Payment Fee',
      amount: 25.00,
      currency: 'EUR',
      deductable: true,
      reducable: true
    }
  ]
};
